/* Management of active recipes */

import {atom} from 'jotai';
import {atomWithImmer} from 'jotai-immer';

import {activesAtom, focusedAtom} from './active';
import {store} from './global';

export const nextRecipe = (incr=1) => {
  const actives = store.get(activesAtom);
  const keys = Object.keys(actives);
  if (keys.length === 0) {
    return;
  }
  const focused = store.get(focusedAtom);
  const idx = keys.indexOf(focused);
  const nextIdx = (idx + incr +keys.length) % keys.length;
  const next = keys[nextIdx];
  store.set(focusedAtom, next);
}

